@for (item of printOptions; track item) {
  <div menu-item (click)="print(item)">{{item}}</div>
}
